import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

type CustomerBookingMobileSkeletonProps = {
    // ...
};

export function CustomerBookingMobileSkeleton({}: CustomerBookingMobileSkeletonProps) {
    return (
        <Box
            component="section"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
            }}
        >
            <Skeleton variant="rectangular" width="100%" height="16px" />
            <Skeleton variant="rectangular" width="100%" height="12px" />
            <Skeleton variant="rectangular" width="100%" height="80px" />
            <Skeleton variant="rectangular" width="100%" height="12px" />
            <Skeleton variant="rectangular" width="100%" height="20px" />
            <Skeleton variant="rectangular" width="100%" height="80px" />
        </Box>
    );
}
